import React from 'react';
import ModalFooter from '@components/sources/source/ModalFooter';
import { H3 } from '@ui-library/typography';
import { SubHeader } from '@components/sources/source/warehouseSource/configureData/style';
import Button from '@ui-library/button';
import { CloseOutlined } from '@ant-design/icons';
import { useModal } from '@ui-library/modal/ModalProvider';
import { MetaData } from '@ui-library/dynamicSelect';
import ColumnSelectionView, { ColumnSelection } from './ColumnSelectionView';
import { Resource } from '../ResourceSelection';

export interface ColumnSelectionModalProps {
  defaultValue?: { [i: string]: ColumnSelection };
  onSubmit?: (columnSelection: { [i: string]: ColumnSelection }) => void;
  sourceRole: string;
  resourceRole: string;
  resources: Resource[];
  metadata: MetaData;
  disabled?: boolean;
}
const ColumnSelectionModal = ({
  defaultValue,
  resourceRole,
  sourceRole,
  resources,
  onSubmit,
  metadata,
  ...props
}: ColumnSelectionModalProps) => {
  const modal = useModal();
  const [selectedCols, setSelectedCols] = React.useState(defaultValue);
  const [disabled, setDisabled] = React.useState(false);
  const onConfirmCL = React.useCallback(() => {
    if (onSubmit) {
      onSubmit(selectedCols!);
    }
  }, [selectedCols]);
  return (
    <div className="column_selection_modal__content_container">
      <div style={{ margin: '4px' }} className="column_selection__header_container">
        <div className="column_selection__header_text">
          <H3>Select columns</H3>
          <SubHeader>
            Select columns for <span style={{ fontWeight: 600 }}>{sourceRole}</span> resource
          </SubHeader>
        </div>
        <div className="column_selection__header_cancel" style={{ display: 'none' }}>
          <Button shape="circle" onClick={modal.close}>
            <CloseOutlined />
          </Button>
        </div>
      </div>
      <ColumnSelectionView
        onChange={setSelectedCols}
        metadata={metadata}
        resources={resources}
        sourceRole={sourceRole}
        defaultValue={defaultValue}
        resourceRole={resourceRole}
        onChangeDisabledStatus={(disabled) => setDisabled(disabled)}
        disabled={props.disabled}
      />
      <ModalFooter
        className="column_selection__footer_container"
        removeCancel={props.disabled}
        confirmText={props.disabled ? 'Close' : 'Confirm'}
        onConfirm={props.disabled ? undefined : onConfirmCL}
        closeOnConfirm={props.disabled}
        disabled={disabled}
      />
    </div>
  );
};

export default ColumnSelectionModal;
